import * as Yup from 'yup';
import { Role } from '@models';

export function useValidationSchema() {
  return Yup.object<Role>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<Role>;
}
